import React, { memo } from 'react'

export default memo(() => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="98"
        height="65"
        viewBox="0 0 98 65"
        fill="none"
    >
        <path
            d="M10.5002 2.55736L65.0598 34.0574L72.3098 21.5L95.3838 62.5346L48.5598 62.6362L55.5598 50.5118L1.00016 19.0118"
            stroke="#FF9900"
            stroke-width="4"
            stroke-linejoin="round"
        />
    </svg>
))
